import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export default (props) => {
  const fontSize = props.fontSize || 25;
  return (
    <div style={{ fontSize }}>
      <FontAwesomeIcon icon="spinner" size={"lg"} spin />{" "}
      {props.text || "Ürünler Yükleniyor..."}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/shared/Loading.js